import { Disposer } from "../Infra/Disposer";
export class SocialLoginCallbackViewModel {
    constructor(container) {
        this.container = container;
        this.disposer = new Disposer();
        this.socialLoginAuthManager = container.socialLoginAuthManager;
    }
    run() {
        this.disposer.reaction(() => this.socialLoginAuthManager.state, () => {
            if (this.socialLoginAuthManager.hasCompletedAuth) {
                const socialLoginAuthData = this.socialLoginAuthManager.getSocialLoginAuthData();
                if (!(socialLoginAuthData === null || socialLoginAuthData === void 0 ? void 0 : socialLoginAuthData.callbackHash)) {
                    console.error("No social login data or hash found");
                    return;
                }
                window.location.hash = socialLoginAuthData.callbackHash;
            }
        }, { fireImmediately: true, name: "SocialLoginCallbackViewModel_smartAuthManagerState" });
    }
    stop() {
        this.disposer.dispose();
    }
}
